import { Component, OnInit, Input } from '@angular/core';

import { Ponto } from "../shared/ponto.model";
import { PontoApiService } from "../shared/ponto-api.service";
import { PontoNavigationService } from "../shared/ponto-navigation.service";
import { UtilService } from "../../../shared/services/util.service";
import { pontosModuleName } from "../shared/data.service";
import { PontoService } from "../shared/ponto.service";

@Component({
    selector: 'app-ponto-table',
    template: require('./ponto-table.component.html'),
    styles: [require('./ponto-table.component.css')]
})
export class PontoTableComponent implements OnInit {
    @Input() list: Ponto[] = [];
    @Input() listFilter: any = {};
    @Input() showActions: boolean = true;
    @Input() showDisabled: boolean = false;
    @Input() loading: boolean = false;

    pontosModuleName: any = pontosModuleName;

    constructor(
        private _pontosApiService: PontoApiService,
        private _pontoNavigationService: PontoNavigationService,
        private _pontoService: PontoService,
        private _utilService: UtilService
    ) { }

    ngOnInit() {
    }

    clickEdit(item: Ponto) {
        this._pontoService.clearSessionStorage();
        this._pontoNavigationService.goToEdit(item.id);
    }

    clickDelete(item: Ponto) {
        const onDelete = (function() {
            this.onDelete(item);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    private onDelete(item: any) {
        const onDone = (function(Response: any) {
            if (!Response.error)  {
                let x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === item.id) {
                        this.list[x].ativo = false;
                        break;
                    }
                }
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        this._pontosApiService.onDelete(item.id, onDone);
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/pontos/ponto-table/ponto-table.component.ts
 **/